module.exports = __webpack_public_path__ + "img/mosquita_rocket.2cbe5c0e.png";